import { alpha } from "@mui/material/styles";
import { Box, Button, Card, Divider, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { AddToHomeScreen } from "react-pwa-add-to-homescreen";
import PageLayout from "../../Components/page-layout/PageLayout";
import { brand } from "../../theme";
import { Fragment } from "react";
import { POLICY_DOWNLOAD_NAME, POLICY_PDF_URL, POLICY_TITLE } from "../../Components/dialog/pdf-viewer/PdfViewerDialog";

const documents = [
  {
    title: "Бланк заявления по ИПУ",
    text: "Заявление на ввод, замену или поверку индивидуального прибора учёта",
    href: "./Files/Бланк заявки по ИПУ.doc",
    format: "DOC",
  },
  {
    title: "Согласие на обработку персональных данных",
    text: "Бланк согласия для заполнения и подписи",
    href: "./Files/Согласие на обработку персональных данных.docx?v=20260920",
    format: "DOCX",
  },
  {
    title: "Инструкция по работе с личным кабинетом",
    text: "Как добавить лицевой счёт, передать показания и запросить квитанции",
    href: "./Files/Инструкция.pdf?v=20260918",
    format: "PDF",
  },
  {
    // блок политики РБР — сразу над политикой АО «ЭнергосбыТ Плюс»
    title: POLICY_TITLE,
    text: "Порядок обработки и защиты персональных данных пользователей личного кабинета",
    href: POLICY_PDF_URL,
    format: "PDF",
    downloadName: POLICY_DOWNLOAD_NAME,
  },
] as { title: string; text: string; href: string; format: string; downloadName?: string }[];

export default function Documents() {
  return (
    <PageLayout title="Документы" subtitle="Бланки и инструкции для скачивания" maxWidth="md">
      <AddToHomeScreen />
      <Card>
        {documents.map((doc, index) => (
          <Fragment key={doc.title}>
            {index > 0 && <Divider />}
            <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={2} sx={{ p: 2.5 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "12px",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: alpha(brand.main, 0.1),
                  color: brand.main,
                }}
              >
                {doc.format === "PDF" ? <PictureAsPdfOutlinedIcon /> : <DescriptionOutlinedIcon />}
              </Box>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="h6">{doc.title}</Typography>
                <Typography color="text.secondary" sx={{ fontSize: 14.5 }}>
                  {doc.text}
                </Typography>
              </Box>
              <Button variant="outlined" startIcon={<DownloadIcon />} href={doc.href}
                target={doc.format === "PDF" && !doc.downloadName ? "_blank" : undefined}
                download={doc.downloadName} sx={{ flexShrink: 0 }}>
                Скачать
              </Button>
            </Stack>
          </Fragment>
        ))}
              <Divider />
              <Fragment key={1234}>
                  <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={2} sx={{ p: 2.5 }}>
                      <Box
                          sx={{
                              width: 48,
                              height: 48,
                              borderRadius: "12px",
                              flexShrink: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              bgcolor: alpha(brand.main, 0.1),
                              color: brand.main,
                          }}
                      >
                          <DescriptionOutlinedIcon />
                      </Box>
                      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Typography variant="h6">{"Политика в отношении обработки персональных данных в АО «ЭнергосбыТ Плюс»"}</Typography>
                          <Typography color="text.secondary" sx={{ fontSize: 14.5 }}>
                              
                          </Typography>
                      </Box>
                      <Button variant="outlined" startIcon={<InsertLinkIcon />} href="https://penza.esplus.ru/privacy/" target="_blank" sx={{ flexShrink: 0 }}>
                          Перейти по ссылке
                      </Button>
                  </Stack>
              </Fragment>
      </Card>
    </PageLayout>
  );
}
